import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inventoryOrderHistoryActions } from "../../../../../store/external/inventory/history/order-history.reducer";
import { TablePagination } from "../../../../common/details-table/table-pagination.component";
import { requestDetailsActions } from "../../../../../store/external/request-reducer/request-details.reducer";

class OrderHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
        }
    }
    componentDidMount() {
        this.props.getInventoryOrderHistory(this.props.circuitId);
    }

    componentWillUnmount() {
        this.props.resetInventoryOrderHistory();
    }

    resizePage = (value) => {
        const { getInventoryOrderHistory, resizeInventoryOrderHistoryLogs } = this.props;
        resizeInventoryOrderHistoryLogs(value);
        getInventoryOrderHistory(this.props.circuitId);
    }

    onColumnSearch = () => {
        this.setState({ displaySearch: !this.state.displaySearch })
        const { getInventoryOrderHistory, circuitId } = this.props;
        getInventoryOrderHistory(circuitId);
    }
    paginationAction = (pageIndex) => {
        const { getInventoryOrderHistory, circuitId } = this.props;
        getInventoryOrderHistory(circuitId, pageIndex);
    }

    openRequestModal = (item) => {
        const { setSelectedRequest } = this.props;
        setSelectedRequest(item);
        this.props.handelLink(item.RequestTypeId)
      }

    render() {
        const { setInventoryOrderHistoryColSearchStr } = this.props;
        const { isInventoryOrderHistoryLoaded } = this.props.inventoryOrderHistory;
        const { Headers, Data, Pagination } = this.props.inventoryOrderHistory.inventoryOrderHistoryItems;
        return (
            <>
                     <TablePagination  
                        key="table-pagination-key"
                        columns={Headers}
                        pageList={Data.Items}                    
                        pages={Pagination}
                        rowClickAction={this.openRequestModal }
                        paginationAction={this.paginationAction }
                        onColumnSearch={() => { this.onColumnSearch() }}
                        onColumnSearchChange={setInventoryOrderHistoryColSearchStr}
                        isColSearchShow={this.props.displaySearch}
                        resizePage={this.resizePage}
                        totalPage={Pagination.TotalEntries}
                        isNotSortable={true}
                        haveLink={true}     
                        isLoading={!isInventoryOrderHistoryLoaded}
                    />          
            </>
        );
    }
}


export default connect(
    state => {
        const { inventoryOrderHistory } = state;

        return {
            inventoryOrderHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryOrderHistoryActions, requestDetailsActions),
        dispatch
    )
)(OrderHistory);